module.exports = __webpack_public_path__ + "img/xiaochengxu1.a7d0b512.jpg";